import { useEndpointFetch } from '../../../../../global/network/useEndpointFetch';

export const useAddFlexibleSessionInstanceFetch = () => {
  return useEndpointFetch<{
    sessionId: string;
    sessionDate: string;
    startTime: string;
    endTime: string;
    name?: string | null;
  }, { flexibleSessionInstanceId: string }>(
    '/vm/session/flexible-instance/add'
  );
};

export const useUpdateFlexibleSessionInstanceFetch = () => {
  return useEndpointFetch<{
    id: string;
    startTime: string;
    endTime: string;
    name?: string | null;
  }, { flexibleSessionInstanceId: string }>(
    '/vm/session/flexible-instance/update'
  );
};

export const useDeleteFlexibleSessionInstanceFetch = () => {
  return useEndpointFetch<{
    id: string;
  }, { flexibleSessionInstanceId: string }>(
    '/vm/session/flexible-instance/delete'
  );
};